import React from "react";
import { Container } from "react-bootstrap";
import SingleLesson from "../../assets/images/single-newone.png";
import BulkLesson from "../../assets/images/bulk-newone.jpg";

const FlexibleNew = ({ heading, content }) => {
  return (
    <div className="keyzi_flexibleNew--wrapper">
      <Container>
        <div className="keyzi_flexibleNew--inner">
          <h2 className="mb-4"> {heading}</h2>
          {/* <p>
            From a single lesson to bulk buys, our packages are designed for
            every learner
          </p> */}
          <div className="flexibleNew-cards--wrapper">
         
            {content ? (
              content.map((e, index) => (
                <div className="flexibleNew--card">
              <div className="card-img">
                <img
                  src={`https://keyzi.com.au/keyzi-admin/public${e.image}`}
                  alt={e.title || "Journey Image"}
                  className="img-fluid"
                />
              </div>
              <div className="card-content">
                <h5>{e.title}</h5>
                <p>{e.description}</p>
              </div>
            </div>
                
              ))
            ) : (
              <>
                <div className="flexibleNew--card">
              <div className="card-img">
                <img
                  src={SingleLesson}
                  alt="single-lesson"
                  className="img-fluid"
                />
              </div>
              <div className="card-content">
                <h5>SINGLE LESSON</h5>
                <p>Dip your toes in with a one-off lesson.</p>
              </div>
            </div>
            <div className="flexibleNew--card">
              <div className="card-img">
                <img src={BulkLesson} alt="bulk-lesson" className="img-fluid" />
              </div>
              <div className="card-content">
                <h5>BULK LESSONS</h5>
                <p>Commit to success and save with lesson packages</p>
              </div>
            </div>
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FlexibleNew;
